import clsx from 'clsx';
import { useEffect } from 'react';
import Text from '../text';
import { ICheckDontSaveChange, IFocusCell, IRangeSelectionProps } from './DataTable';
import styles from "./DataTable.module.css";
interface ICellProps {

    cell: any,
    focusedCell?: IFocusCell,
    rowIndex: number,
    checkDontSaveChange?: ICheckDontSaveChange,
    onFocuseCellChanged?: (data: IFocusCell) => void,
    selectedCells: any,
    rangeSelection?: IRangeSelectionProps,
    handleMouseDown: (rowIndex: number, colIndex: number) => void,
    handleMouseMove: (rowIndex: number, colIndex: number) => void,
    rowId: any,
    rowData: any,
    isRowSelectedSingle: boolean,
    colIndex: number;
    isHaveFocusedCell?: boolean
}
const Cell = (props: ICellProps) => {
    const { cell, handleMouseDown, handleMouseMove, rowId, rowData, isRowSelectedSingle, onFocuseCellChanged, colIndex, isHaveFocusedCell, selectedCells, rowIndex } = props;
    let isDontSave: boolean = false;
    if (
        props.checkDontSaveChange &&
        cell.column.isAllowFocus
    ) {
        const rootRowData =
            props.checkDontSaveChange.rootDataSource.find(
                (x) => x.id === rowId
            );
        if (rootRowData) {
            const rootValue =
                rootRowData[cell.column.dataField];
            const currentValue =
                rowData[cell.column.dataField];
            if (rootValue !== currentValue) {
                isDontSave = true;
            }
        }
    }
    const cellStyle = {
        width: cell.column.width,
        minWidth: cell.column.minWidth,
        fontWeight: cell.column.isMainColumn ? "600" : 400,
        whiteSpace: "break-spaces" as const,
        textAlign: cell.column.align,
        ...(isRowSelectedSingle && { backgroundColor: "#fff8c5" }),
        ...(rowData && { color: rowData.backgroundColor }),
        ...(cell.column.fixedLeft !== undefined && { left: cell.column.fixedLeft }),
    };
    const handleFocus = cell.column.isAllowFocus && onFocuseCellChanged
        ? () => onFocuseCellChanged({
            rowData: rowData,
            dataField: cell.column.dataField,
        })
        : undefined;
    return (
        <td
            {...cell.getCellProps()}
            key={colIndex}
            style={cellStyle}
            tabIndex={
                cell.column.isAllowFocus ? 0 : undefined
            }
            onFocus={handleFocus}
            className={clsx(
                props.focusedCell && isHaveFocusedCell && props.focusedCell.dataField === cell.column.dataField
                    ? styles.focused
                    : "",
                cell.column.fixedLeft !== undefined ? styles.fixed_column : "",
                isDontSave ? styles.isDoneSave : "",
                selectedCells.has(`${rowIndex}-${colIndex}`) ? styles.rangeSelected : ""
            )}
            onMouseDown={props.rangeSelection ? () => handleMouseDown(rowIndex, colIndex) : undefined}
            onMouseMove={props.rangeSelection ? () => handleMouseMove(rowIndex, colIndex) : undefined}
        >
            {/* {cell.column.isHideZeroValue ?
                <>
                    {rowData[cell.column.dataField]?.toString() === "0" ? "" : cell.render("Cell")}
                </>
                :
                <>
                    {cell.column.cellRender
                        ? cell.column.cellRender(rowData)
                        : cell.render("Cell")}
                </>
            } */}
            {cell.column.cellRender
                ? cell.column.cellRender(rowData)
                : <Text
                    text={
                        (cell.column.isHideZeroValue && rowData[cell.column.dataField]?.toString() === "0")
                            ? ""
                            : (rowData[cell.column.dataField]?.toString() ?? "")
                    }
                />
            }

        </td>
    );
};

export default Cell;